export const contentTableConfig = {
  title: '转移通知记录',
  propList: [
    {prop: 'nickName', label: '客户昵称', minWidth: '120', slotName: 'consumer', align: 'left'},
    {prop: 'userId', label: '客户UserID', minWidth: '160'},
    {prop: 'belongEmpId', label: '所属企微账号', minWidth: '120'},
    {prop: 'usedBy', label: '使用人', minWidth: '100'},
    {prop: 'groupName', label: '所属分组', minWidth: '100'},
    {prop: 'belongCorpName', label: '所属主体', minWidth: '120'},
    {prop: 'createdTime', label: '再次加入时间', minWidth: '120'},
    {prop: 'thirdParty', label: '再次加入第三方', minWidth: '120'},
    {prop: 'sourceLabel', label: '再次加入来源渠道', minWidth: '120'},
    {prop: 'takeoverStatus', label: '接替状态', minWidth: '80', slotName: 'takeoverStatus'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
